import { render, staticRenderFns } from "./SupplierEditDialog.vue?vue&type=template&id=4af37742&"
import script from "./SupplierEditDialog.vue?vue&type=script&lang=js&"
export * from "./SupplierEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports